import React, { useEffect, useRef } from 'react';

import { useParams } from 'react-router-dom';

import styles from './styles.js';
import { Pages, assetUrl } from 'pages';
import Page01 from 'pages/Page01';

const Home = () => {
  const { id } = useParams();
  const content = useRef();
  let currentId = parseInt(id ? id : 1, 10);
  currentId =
    currentId > Pages.length ? Pages.length : currentId < 0 ? 0 : currentId;
  const nextId = currentId + 1 < Pages.length ? currentId + 1 : Pages.length;
  const prevId = currentId - 1 >= 0 ? currentId - 1 : null;

  useEffect(() => {
    content.current.scrollTo({
      top: 0,
      left: 0,
      behavior: 'auto'
    });
  }, [currentId]);

  return (
    <div
      style={{
        height: '100vh',
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw'
      }}
      className="crt"
    >
      <div ref={content}>
        {(isNaN(currentId) && <Page01 story={id} assetUrl={assetUrl} />) ||
          Pages[currentId]}
      </div>
    </div>
  );
};
export default Home;
